 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"app-modules-auth-confirmation-required-confirmation-required-module":"app-modules-auth-confirmation-required-confirmation-required-module","app-modules-errors-errors-module":"app-modules-errors-errors-module","app-modules-public-public-module":"app-modules-public-public-module","default~app-modules-auth-forgot-password-forgot-password-module~app-modules-auth-reset-password-rese~564b91d0":"default~app-modules-auth-forgot-password-forgot-password-module~app-modules-auth-reset-password-rese~564b91d0","common":"common","app-modules-auth-forgot-password-forgot-password-module":"app-modules-auth-forgot-password-forgot-password-module","app-modules-auth-reset-password-reset-password-module":"app-modules-auth-reset-password-reset-password-module","app-modules-auth-sign-in-sign-in-module":"app-modules-auth-sign-in-sign-in-module","default~app-modules-auth-sign-up-sign-up-module~app-modules-main-contestants-contestants-module~app-~aff9de1b":"default~app-modules-auth-sign-up-sign-up-module~app-modules-main-contestants-contestants-module~app-~aff9de1b","default~app-modules-auth-sign-up-sign-up-module~app-modules-backend-backend-module~app-modules-game-~4656aa16":"default~app-modules-auth-sign-up-sign-up-module~app-modules-backend-backend-module~app-modules-game-~4656aa16","default~app-modules-auth-sign-up-sign-up-module~app-modules-main-contestants-contestants-module~app-~dab90014":"default~app-modules-auth-sign-up-sign-up-module~app-modules-main-contestants-contestants-module~app-~dab90014","app-modules-auth-sign-up-sign-up-module":"app-modules-auth-sign-up-sign-up-module","default~app-modules-backend-backend-module~app-modules-game-game-module~app-modules-public-contests-~1b336160":"default~app-modules-backend-backend-module~app-modules-game-game-module~app-modules-public-contests-~1b336160","app-modules-backend-backend-module":"app-modules-backend-backend-module","default~app-modules-game-game-module~app-modules-main-contests-contests-module~app-modules-main-sche~d0577211":"default~app-modules-game-game-module~app-modules-main-contests-contests-module~app-modules-main-sche~d0577211","default~app-modules-game-game-module~app-modules-public-contests-view-view-module":"default~app-modules-game-game-module~app-modules-public-contests-view-view-module","app-modules-game-game-module":"app-modules-game-game-module","app-modules-public-contests-contests-module":"app-modules-public-contests-contests-module","app-modules-public-slug-slug-module":"app-modules-public-slug-slug-module","app-modules-public-sponsorship-sponsorship-module":"app-modules-public-sponsorship-sponsorship-module","default~app-modules-main-contestants-contestants-module~app-modules-main-users-users-module~app-modu~570fa318":"default~app-modules-main-contestants-contestants-module~app-modules-main-users-users-module~app-modu~570fa318","default~app-modules-main-contestants-contestants-module~app-modules-public-profile-profile-module":"default~app-modules-main-contestants-contestants-module~app-modules-public-profile-profile-module","app-modules-public-profile-profile-module":"app-modules-public-profile-profile-module","default~app-modules-main-schedule-schedule-module~app-modules-public-schedule-schedule-module~app-mo~fc83678e":"default~app-modules-main-schedule-schedule-module~app-modules-public-schedule-schedule-module~app-mo~fc83678e","app-modules-public-wallets-wallets-module":"app-modules-public-wallets-wallets-module","default~app-modules-main-schedule-schedule-module~app-modules-public-schedule-schedule-module":"default~app-modules-main-schedule-schedule-module~app-modules-public-schedule-schedule-module","app-modules-public-schedule-schedule-module":"app-modules-public-schedule-schedule-module","app-modules-main-dashboard-dashboard-module":"app-modules-main-dashboard-dashboard-module","app-modules-main-payments-payments-module":"app-modules-main-payments-payments-module","app-modules-main-configs-configs-module":"app-modules-main-configs-configs-module","app-modules-main-notifications-notifications-module":"app-modules-main-notifications-notifications-module","app-modules-main-profile-profile-module":"app-modules-main-profile-profile-module","app-modules-main-roles-roles-module":"app-modules-main-roles-roles-module","app-modules-main-wallets-wallets-module":"app-modules-main-wallets-wallets-module","app-modules-main-pages-pages-module":"app-modules-main-pages-pages-module","app-modules-main-sponsorships-sponsorships-module":"app-modules-main-sponsorships-sponsorships-module","app-modules-main-users-users-module":"app-modules-main-users-users-module","default~app-modules-main-contests-contests-module~app-modules-main-layouts-layouts-module~app-module~3ed09fd9":"default~app-modules-main-contests-contests-module~app-modules-main-layouts-layouts-module~app-module~3ed09fd9","default~app-modules-main-contests-contests-module~app-modules-main-schedule-schedule-module":"default~app-modules-main-contests-contests-module~app-modules-main-schedule-schedule-module","default~app-modules-main-contests-contests-module~app-modules-public-contests-view-view-module":"default~app-modules-main-contests-contests-module~app-modules-public-contests-view-view-module","app-modules-main-contests-contests-module":"app-modules-main-contests-contests-module","app-modules-main-schedule-schedule-module":"app-modules-main-schedule-schedule-module","app-modules-main-layouts-layouts-module":"app-modules-main-layouts-layouts-module","app-modules-public-contests-view-view-module":"app-modules-public-contests-view-view-module","app-modules-main-contests-prizes-prizes-module":"app-modules-main-contests-prizes-prizes-module","app-modules-main-contestants-contestants-module":"app-modules-main-contestants-contestants-module"}[chunkId]||chunkId) + "-es2015.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
